import { useMemo, useCallback } from 'react';

import { useWindowSize } from 'react-use';

import { useBreakpoints } from './use-breakpoints';
import { clamp } from '../misc/utilities';

export const MAX_W = 1600;
export const DESIRED_P_VW = 5;
export const MIN_P_PX = 16;
export const MAX_P_PX = 80;
export const NUM_FULL_W_BREAKPOINTS = 3;

export const useContainer = () => {
	const { smallerThanNthBreakpoint } = useBreakpoints();
	const { width } = useWindowSize();

	const offset = useMemo(
		() =>
			smallerThanNthBreakpoint(NUM_FULL_W_BREAKPOINTS)
				? 0
				: 0.9 * width < 1600
					? (width - 0.9 * width) / 2
					: (width - 1600) / 2,
		[smallerThanNthBreakpoint, width],
	);
	const paddingX = useCallback(() => clamp(MIN_P_PX, DESIRED_P_VW, MAX_P_PX, width), [width]);

	// based on Container component
	return {
		MAX_W,
		DESIRED_P_VW,
		MIN_P_PX,
		MAX_P_PX,
		NUM_FULL_W_BREAKPOINTS,
		offset, // not including padding
		paddingX,
	};
};
